/**
 * @file 俄罗斯域名改造， 根据cookie中 domain_suffix 信息设置api请求域名
 * @date 2020/04/01
 * @author hpuhouzhiqiang@didiglobal.com
 */
// 改造文档地址
// http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=336205805

/**
 * 获取cookie信息转换请求的业务域名
 * @param {*} domian  业务请求的域名
 */
export default function checkDomianFn(domain) {
  var domainSuffix = getCookie("domain_suffix");
  var domainArr = domain.split(".");

  if (domainSuffix) {
    domainArr[0] += domainSuffix;
    return domainArr.join(".");
  }

  var pageDomain = location.hostname;
  var pageDomainArr = pageDomain.split("."); // 测试环境域名 正则  /sim[0-9]+[-\w]+test.intra.xiaojukeji.com$/

  var ibtTestDomain = /sim[0-9]+[-\w]+test.intra.xiaojukeji.com$/;
  var ibtTestDomainNew = /dsim[0-9]+[-\w]+.intra.xiaojukeji.com$/;

  if (ibtTestDomain.test(pageDomain) || ibtTestDomainNew.test(pageDomain)) {
    return domain;
  } // 默认目前线上都是page.didiglobal.com域名 不存在 page-xx.didiglobal.com的域名
  // 否则就会存在 page-xx-g.didiglobal.com 这里判断条件就会不准确


  if (pageDomainArr[0].indexOf("-") > 0) {
    var domainPreFixArr = pageDomainArr[0].split("-");
    var pageSuffix = domainPreFixArr[domainPreFixArr.length - 1];
    domainArr[0] += "-" + pageSuffix;
    return domainArr.join(".");
  } // 其它情况不做处理


  return domain;
}
/**
 * 获取cookie信息
 * @param {*} cname 根据key获取cookie中value值
 */

function getCookie(cname) {
  var name = cname + "=";
  var ca = document && document.cookie && document.cookie.split(";") || [];
  if (ca.length === 0) return "";

  for (var i = 0; i < ca.length; i++) {
    var c = ca[i].trim();
    if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
  }

  return "";
}

export { checkDomianFn };
